/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Result_UnintelligibleInputs */



/**
* | output |
* | --- |
* | "I couldn't tell whether that was a yes, so nothing was done" |
*
* @param {Chat_Tool_Result_UnintelligibleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_unintelligible = /** @type {((inputs?: Chat_Tool_Result_UnintelligibleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_UnintelligibleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ich konnte kein Ja erkennen, daher wurde nichts ausgeführt")
	return /** @type {LocalizedString} */ ("I couldn't tell whether that was a yes, so nothing was done")
});